import { ExtendedWMSParams, WMS } from "../types";

export function getExtendedWMSParams(wmsParams: WMS): ExtendedWMSParams {
  return { ...wmsParams, tiled: true };
}
